import { components } from '@/framework';
import TwWysiwyg from '../components/TwWysiwyg';

export default {
  install(Vue) {
    components(Vue, {
      'tw-wysiwyg': TwWysiwyg,
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/index.js